export default function Group({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7 7.4375C8.7 8.78419 7.59241 9.875 6.225 9.875C4.85759 9.875 3.75 8.78419 3.75 7.4375C3.75 6.09081 4.85759 5 6.225 5C7.59241 5 8.7 6.09081 8.7 7.4375ZM1 13.8472C1 11.9261 4.48117 10.9583 6.225 10.9583C7.96883 10.9583 11.45 11.9261 11.45 13.8472V18H1V13.8472ZM20.25 7.4375C20.25 8.78419 19.1425 9.875 17.775 9.875C16.4076 9.875 15.3 8.78419 15.3 7.4375C15.3 6.09081 16.4076 5 17.775 5C19.1425 5 20.25 6.09081 20.25 7.4375ZM13.65 6.625C13.65 7.52281 12.9116 8.25 12 8.25C11.0884 8.25 10.35 7.52281 10.35 6.625C10.35 5.72719 11.0884 5 12 5C12.9116 5 13.65 5.72719 13.65 6.625ZM12.55 13.8472C12.55 11.9261 16.0312 10.9583 17.775 10.9583C19.5188 10.9583 23 11.9261 23 13.8472V18H12.55V13.8472Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 10.5417C14.8315 10.5866 14.6652 10.6342 14.5022 10.6846C13.7627 10.9134 13.0159 11.2224 12.4357 11.6359C12.2804 11.7467 12.133 11.8681 12 12C11.8671 11.8681 11.7197 11.7467 11.5643 11.6359C10.9841 11.2224 10.2373 10.9134 9.49778 10.6846C9.33487 10.6342 9.1686 10.5866 9 10.5417C9.96147 10.1811 11.1979 10 12 10C12.8021 10 14.0385 10.1811 15 10.5417Z"
        fill={color}
      />
    </svg>
  );
}
